/* eslint no-process-env:0 */

import 'babel-polyfill';
import _ from 'lodash';
import React from 'react';
import {render} from 'react-dom';
import {browserHistory, Router} from 'react-router';
import {Provider} from 'react-redux';
import ErrorPage from '../reactModules/pages/Error';
import routes from '../reactModules/routes/reactRoutes';
import configureStore from './configureStore';
import {AdService} from 'legacy-advertising';
import {AD_SERVICE} from '../reactModules/redux/actions';
import appConfig from '../appConfig/AppConfig';

/**
 * Checks to see if the DOM is ready
 * @param  {function}   fn A callback to run after the DOM is ready.
 * @return {undefined}  returns nothing
 */
function checkDom(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        fn();
      }
    });
  }
}

/**
 * Creates the react components with bootstrapped data on the client side.
 * @return {undefined} returns nothing
 */
function startup() {
  const config = appConfig();
  let renderElement = null;
  const preloadedState = window.__PRELOADED_STATE__;
  const hasError = _.get(preloadedState, 'errorStore.errorCode', false);
  const store = configureStore(preloadedState);

  // inject an instance of the AdService
  const adService = new AdService();

  adService.initialize(config.advertising);
  store.dispatch({type: AD_SERVICE, data: {adService}});

  if (hasError) {
    renderElement = (
      <Provider store={store}>
        <ErrorPage />
      </Provider>
    );
  } else {
    renderElement = (
      <Provider store={store}>
        <Router history={browserHistory} routes={routes} />
      </Provider>
    );
  }

  render(renderElement, document.getElementById('root'));
}

checkDom(startup);



// WEBPACK FOOTER //
// ./src/appModules/app.js